'use strict'
import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import Auth from '@/modules/auth/models/Auth'
import authLogout from '@/modules/auth/mixins/authLogout'

// get logout function from mixin
const logout = authLogout.methods.logoutReturnUrl

// Full config:  https://github.com/axios/axios#request-config

let config = {
  baseURL:
    process.env.NODE_ENV === 'production'
      ? window.location.origin
      : process.env.VUE_APP_API_URL,
  headers: {},
  withCredentials: true // Check cross-site Access-Control
}

config.headers.Accept = 'application/json'
// axios.defaults.withCredentials = true
//config.headers.crossdomain = true
//config.headers['Access-Control-Allow-Origin'] = '*'

const _axios = axios.create(config)

_axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  response => {
    if (typeof response.data.data !== 'undefined') {
      return response.data.data
    }
    // Do something with response data
    return response.data
  },
  async error => {
    if (
      error.response.status === 401 &&
      error.response.data.error === 'invalid_credentials'
    ) {
      return Promise.reject(error)
    }

    let url = error.response.request.responseURL
    const type = router.currentRoute.meta.type
    if (error.response.status === 401) {
      if (url.includes('oauth/token')) {
        // Refresh token has failed. Logout the user
        logout(type).then(response => {
          window.location.replace(response)
        })
      } else {
        // Refresh the access token
        try {
          await Auth.dispatch('refreshToken', `${type}s`)
          // Retry the original request
          return axios({
            method: error.config.method,
            url: error.config.url,
            data: error.config.data ? JSON.parse(error.config.data) : {},
            params: error.config.params
          })
            .then(response => {
              if (typeof response.data.data !== 'undefined') {
                return response.data.data
              }
              // Do something with response data
              return response.data
            })
            .catch(error => {
              return Promise.reject(error)
            })
        } catch (e) {
          // Refresh has failed - reject the original request
          throw error
        }
      }
    } else if (error.response.status === 400) {
      if (url.includes('oauth/token')) {
        logout(type).then(response => {
          window.location.replace(response)
        })
        // Refresh token has failed. Logout the user
        return Promise.reject(error)
      }
    }
    // If error was not 401 just reject as is
    return Promise.reject(error)
  }
)

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Vue.prototype.$axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
